import React from 'react';
import { Route } from 'react-router';
import configureStore from './store/configureStore';

import { getSignupOptions } from './actions/signupActions';

import App from './components/App';
import SignupPage from './components/Signup/SignupPage';

export const store = configureStore();

export const routes = (
  <Route path={'/'} component={App}>
    <Route
      path={'ayso-home/signup'}
      component={SignupPage}
      onEnter={() => {
        store.dispatch(getSignupOptions());
      }}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./library/app/routes.js